import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api.js';

const BALANCE = ['payouts', 'balance'] as const;

export function usePayoutBalance() {
  return useQuery({
    queryKey: BALANCE,
    queryFn: () => api.payouts.balance(),
  });
}

export function useSetETransferEmail() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (email: string) => api.payouts.setEmail(email),
    onSuccess: () => qc.invalidateQueries({ queryKey: BALANCE }),
  });
}

export function useRequestPayout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.payouts.request(),
    onSuccess: () => qc.invalidateQueries({ queryKey: BALANCE }),
  });
}
